// extracted by mini-css-extract-plugin
export default {"productGrid":"Haa-z","centerLink":"Iaa-z","productSection":"Jaa-z","item":"Kaa-z","ctaButton":"Laa-z"};